// extracted by mini-css-extract-plugin
export default {"user":"UserButton_user__+NtMQ","block":"UserButton_block__yHpVq","logOut":"UserButton_logOut__OaWnb"};